export type FormFieldType = 'text' | 'textarea' | 'select' | 'radio' | 'number' | 'checkbox';

export interface FormFieldOption {
  value: string;
  label: string;
}

export interface VisibilityRule {
  field: string;
  equals: string | string[];
}

export interface FormFieldDef {
  key: string;
  type: FormFieldType;
  label: string;
  placeholder?: string;
  helpText?: string;
  required: boolean;
  locked: boolean;
  options?: FormFieldOption[];
  // Names a server-served vocabulary that supplies this field's options at
  // render time, in place of the inline `options` list. Keeps a reviewed
  // vocabulary out of the admin-editable schema so the two cannot drift.
  optionsSource?: 'equipment_types';
  visibleWhen?: VisibilityRule;
  defaultValue?: any;
}

export interface FormSection {
  id: string;
  title: string;
  collapsible?: boolean;
  fields: FormFieldDef[];
}

export interface FormSchemaDefinition {
  formKind: string;
  sections: FormSection[];
}

export const FORM_KIND_LABELS: Record<string, string> = {
  equipment: 'Equipment',
  equipmentInstrument: 'Equipment Instrument',
  node: 'Node / Line',
  nodeInstrument: 'Node Instrument',
  pfd_equipment: 'PFD Equipment',
  pfd_node: 'PFD Stream',
  pfd_instrument: 'PFD Instrument',
};

export const FORM_KINDS = ['equipment', 'equipmentInstrument', 'node', 'nodeInstrument', 'pfd_equipment', 'pfd_node', 'pfd_instrument'] as const;
export type FormKind = (typeof FORM_KINDS)[number];
